
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-slate-800 border-b border-slate-700 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
                AssessorLink
              </h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
              Home
            </a>
            <a href="/states" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
              Browse States
            </a>
            <a href="/search" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
              Search
            </a>
            <a href="/resources" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
              Resources
            </a>
            <a href="/contact" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
              Contact
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-2 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit LoanGuide Pro
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-300 hover:text-white cursor-pointer"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-700">
            <div className="flex flex-col space-y-4">
              <a href="/" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
                Home
              </a>
              <a href="/states" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
                Browse States
              </a>
              <a href="/search" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
                Search
              </a>
              <a href="/resources" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
                Resources
              </a>
              <a href="/contact" className="text-slate-300 hover:text-white transition-colors cursor-pointer">
                Contact
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-2 rounded-lg font-semibold transition-colors cursor-pointer text-center whitespace-nowrap"
              >
                Visit LoanGuide Pro
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
